import response from './response'


export default key => {
    return new Promise(resolve => {
        response.onload(res => {
            let target = res.find(v => v.keyname == key)
            resolve(target && target.value)
        })
    })
}